// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iRwZ","clinicsSelect":"styles_clinicsSelect__32uLi"};